// extracted by mini-css-extract-plugin
export var createdDate = "_lv-1";
export var divider = "_lv-2";
export var headerDivider = "_lv-3";
export var messagesCard = "_lv-0";
export var messagesContainer = "_lv-7";
export var messagesContainerWrapper = "_lv-4";
export var pointerCapturingButtonBoxes = "_lv-a";
export var showLeftPanelButton = "_lv-9";
export var showMoreButton = "_lv-c";
export var showMoreButtonContainer = "_lv-b";
export var summaryTitle = "_lv-6";
export var systemMessageCardWrapper = "_lv-d";
export var topButtons = "_lv-8";
export var withPadding = "_lv-5";